import React, { useContext } from 'react';
import { styled } from 'linaria/react';
import { ReactComponent as Cart } from '../../../svg/Cart.svg';
import { DrawerTrigger } from '@jetshop/ui/Modal/Drawer';
import { useAddToCart } from '../../../hooks/useAddToCart';
import { QuickBuyContext } from './QuickBuyContext';
import { useTrackProductAdd } from '@jetshop/core/components/Mutation/AddToCart/addToCartUtils';

const QuickBuyButtonWrapper = styled('button')`
  background: #004e42;
  height: 34px;
  width: 100%;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 10px;
  font-weight: 700;
  font-size: 11px;
  line-height: 13px;
  letter-spacing: 0.1em;
  text-transform: uppercase;

  svg {
    color: white;
    width: 13px;
    height: 15px;
    margin-right: 10px;
    path {
      fill: white;
    }
  }

  &.icon {
    border-radius: 50%;
    svg {
      height: 15px;
      width: 15px;
      margin-right: 0;
    }
  }
`;

/**
 * The QuickBuyButton function renders a button that when clicked, either adds product to cart or displays the QuickBuyFlyout component.
 *
 * @param {object} product Pass the product details
 * @param {number} qty Set the default quantity of the product
 *
 * @return A button that can add the product to the cart
 *
 * @docauthor Anders Zetterström @ R3
 */
export const QuickBuyButton = ({ icon, product, qty = 1 }) => {
  const trackAddProductVariant = useTrackProductAdd(product);

  const trackAddToCart = () => {
    trackAddProductVariant(product, qty);
  };
  const { addProduct } = useAddToCart(trackAddToCart);
  const { setQuickBuyProduct, setQuickBuyQty } = useContext(QuickBuyContext);

  if (!product?.stockStatus?.buyable) {
    return null;
  }

  return (
    <div className="quick-buy-button">
      {product?.variants?.values?.length > 0 ? (
        <DrawerTrigger preventOverflow={true} id="quick-buy-drawer">
          {drawer => (
            <QuickBuyButtonWrapper
              onClick={e => {
                // Disables link click
                e.preventDefault();
                setQuickBuyProduct(product);
                setQuickBuyQty(qty);
                console.log('Drawer: ', drawer);
                drawer.showTarget();
              }}
            >
              <span>
                <Cart />
                {!icon && 'Lägg i varukorg'}
              </span>
            </QuickBuyButtonWrapper>
          )}
        </DrawerTrigger>
      ) : (
        <QuickBuyButtonWrapper
          className={icon && 'icon'}
          onClick={e => {
            // Disables link click
            e.preventDefault();
            addProduct(product, qty);
          }}
        >
          <span>
            <Cart />
            {!icon && 'Lägg i varukorg'}
          </span>
        </QuickBuyButtonWrapper>
      )}
    </div>
  );
};
